import styled from 'styled-components';
import { Text } from '../shared/Text';
import { StatsBase } from '../../types/TixAPITypes';
import { FlexRowMiddle } from '../shared/Flex';
import { formatCurrency } from '../../scripts/scripts';
import { TextSkeleton } from '../shared/Skeleton';
import { Icon } from '../shared/Icon';
import { ReactNode } from 'react';
import IconTicket from '../../../public/icons/ticket.svg?react';
import IconCart from '../../../public/icons/cart.svg?react';
import IconChart from '../../../public/icons/chart.svg?react';
import IconMoneyBag from '../../../public/icons/moneybag.svg?react';
import { theme } from '../../theme/theme';

const StyledOSHeaderStats = styled(FlexRowMiddle)`
	width: 100%;
	padding: 1rem 0 0 0;
	display: grid;
	grid-template-columns: 1fr 1fr 1fr 1fr;

	row-gap: 0.5rem;
	align-items: flex-start;

	align-items: center;

	border-top: 2px solid ${({ theme }) => theme.panel_main_border};
`;

export function OSStatsHeaderMobile({ stats, showToBeSold }: { stats?: StatsBase; showToBeSold?: boolean }) {
	return (
		<StyledOSHeaderStats className="eventStatsMobile">
			<StatContainer
				icon={<IconChart />}
				color={!stats?.totalROI ? 'text_desc_alt' : stats.totalROI > 0 ? 'text_green' : 'text_red'}
			>
				<TextSkeleton width="20px" height="13px">
					{!stats ? undefined : stats.totalROI === null ? '0%' : `${stats.totalROI.toFixed(0)}%`}
				</TextSkeleton>
			</StatContainer>

			<StatContainer
				icon={<IconMoneyBag />}
				color={!stats?.totalProfit ? 'text_desc_alt' : stats.totalROI > 0 ? 'text_green' : 'text_red'}
			>
				<TextSkeleton width="20px" height="13px">
					{!stats ? undefined : formatCurrency(stats.totalProfit, 'EUR', 0)}
				</TextSkeleton>
			</StatContainer>

			<StatContainer icon={<IconTicket />}>
				<TextSkeleton width="20px" height="13px">
					{!stats
						? undefined
						: showToBeSold
							? formatCurrency(stats.totalValueToBeSold, 'EUR', 0)
							: formatCurrency(stats.totalValueUnsold, 'EUR', 0)}{' '}
				</TextSkeleton>
			</StatContainer>

			<StatContainer icon={<IconCart />} color="text_desc_alt">
				<TextSkeleton width="20px" height="13px">
					{!stats ? undefined : `${formatCurrency(stats.totalSoldAll, 'EUR', 0)}`}
				</TextSkeleton>
			</StatContainer>
		</StyledOSHeaderStats>
	);
}

const StyledStatContainer = styled(FlexRowMiddle)`
	height: 100%;
	padding: 0.25rem 0;

	justify-content: center;
	border-right: 2px solid ${({ theme }) => theme.panel_main_border};

	column-gap: 0.75rem;
	&:last-of-type {
		border-right: 0;
	}
	p {
		line-height: 100%;
	}
`;

function StatContainer({
	icon,
	children,
	color,
}: {
	icon: ReactNode;
	children: ReactNode;
	color?: keyof typeof theme;
}) {
	return (
		<StyledStatContainer>
			<Icon $colorFill={color ? color : 'text_title_main'} style={{ height: 24, maxWidth: 16 }}>
				{icon}
			</Icon>
			<Text $color={color ? color : 'text_title_main'} $size="1.2rem" $weight="400">
				{children}
			</Text>
		</StyledStatContainer>
	);
}
